import React from 'react';
import { Box } from '@mui/material';

import AdvisorHelpAndSupport from './AdvisorHelpAndSupport';

const AdvisorDashboard = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'flex-start',
        }}
      >
        <AdvisorHelpAndSupport />
      </Box>
    </Box>
  );
};

export default AdvisorDashboard;
